import React from 'react'
import {Typography, Card} from '@material-ui/core'
import {WithContext as ReactTags} from 'react-tag-input'

import SynonymTable from './SynonymTable'

class NestedSynonymCard extends React.Component {
  handleAddition = newTag => {
    const {id, ...tags} = newTag
    const tag = Object.keys(tags)[0]
    this.props.onNewTag({
      [this.props.name]: {
        [tag]: {
          changed: {
            $set: true,
          },
          synonyms: {
            $push: [tags[tag]],
          },
        },
      },
    })
  }

  handleDelete = tag => index => {
    const synonyms = this.props.data[tag].synonyms.filter((s, i) => i !== index)
    const tagQuery = {
      [tag]: {
        changed: {
          $set: true,
        },
        synonyms: {
          $set: synonyms,
        },
      },
    }
    const output = this.props.child
      ? {
          [this.props.name]: {
            child: tagQuery,
          },
        }
      : {
          [this.props.name]: tagQuery,
        }

    this.props.onNewTag(output)
  }

  handleChildAddition = newTag => {
    this.props.onNewTag({
      [this.props.name]: newTag,
    })
  }

  render() {
    const {data, title} = this.props
    return (
      <Card style={{padding: '20px', marginBottom: '20px'}}>
        <Typography variant="title" style={{marginBottom: '20px'}}>
          {title}
        </Typography>
        {Object.keys(data).map(wordRow => (
          <Card key={wordRow} style={{padding: '20px', marginBottom: '20px'}}>
            <div className="flex items-center" style={{marginBottom: 20}}>
              <Typography variant="subheading" style={{marginRight: 20}}>
                {wordRow}
              </Typography>
              <ReactTags
                allowDragDrop={false}
                autofocus={false}
                handleDelete={this.handleDelete(wordRow)}
                handleAddition={this.handleAddition}
                labelField={wordRow}
                tags={data[wordRow].synonyms.map(synonym => ({
                  id: synonym,
                  [wordRow]: synonym,
                }))}
              />
            </div>
            <SynonymTable
              onNewTag={this.handleChildAddition}
              name={wordRow}
              data={data[wordRow].child}
              child
            />
          </Card>
        ))}
      </Card>
    )
  }
}

export default NestedSynonymCard



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/aiSetting/NestedSynonymCard.js